import * as React from 'react';
import { PrimaryButton, Button } from 'office-ui-fabric-react';
import { AppButtonProps } from './AppButton.props';
import { getAppButtonStyles } from './AppButton.styles';

/**
 * AppButton component is the Transcription Application's implementation of the
 * Fabric UI's PrimaryButton. The need from this component arises due to the
 * following 2 reasons:
 * 1. Styles: We want to keep our default app styles for buttons tightly coupled
 * with the component so that any application level changes only have to be made
 * at a single point in the code.
 * 2. Functionality: We would like to know exactly how our Button component behaves.
 * Creating our own implementation allows us to restrict the props being passed down
 * to the base component, thus allowing us to predict it's functionality accurately.
 */
export const AppButton: React.FunctionComponent<AppButtonProps> = (props: AppButtonProps): JSX.Element => {

  const { ariaDescription, buttonRef, disabled, id, styles, text, menuProps } = props;
  // Here we merge the user passed styles in the props with our default
  // application styles present in AppButton.styles file.
  const appButtonStyles = getAppButtonStyles(styles);

  const onClick = (clickEvent: React.MouseEvent<Button>) => {
    const { id, onExecute } = props;

    if (onExecute) {
      onExecute({ id, clickEvent });
    }
  };

  return (
    <PrimaryButton
      componentRef={buttonRef}
      ariaDescription={ariaDescription}
      disabled={disabled}
      id={id}
      styles={appButtonStyles}
      text={text}
      onClick={onClick}
      menuProps = {menuProps}
    />
  );
}